export function isStringEmptyOrUndefined(
  value: string,
  errorMessage: string
): Error | undefined {
  if (value === "" || value === undefined) {
    return new Error(errorMessage);
  }
}
